import { render } from "./FullSplash.vue?vue&type=template&id=36c97006&scoped=true"
import script from "./FullSplash.vue?vue&type=script&lang=js"
export * from "./FullSplash.vue?vue&type=script&lang=js"

import "./FullSplash.vue?vue&type=style&index=0&id=36c97006&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c97006"]])

export default __exports__